export const resolveResponsePagination = (
  response = {},
  defaultValue = {
    perPage: 10,
    currentPage: 1,
    lastPage: 1,
    total: 10,
  }
) => {
  if (!response || typeof response !== 'object') return defaultValue;

  return {
    perPage: response.per_page ?? defaultValue.perPage,
    currentPage: response.current_page ?? defaultValue.currentPage,
    total: response.total ?? defaultValue.total,
    lastPage: response.last_page ?? defaultValue.lastPage,
  };
};
